import JobsListPage from '@/pages/jobs/list'
import { WorkspacePortalProvider } from '@/contexts/workspace-portal-context'

export default function EventsListPage() {
  return (
    <WorkspacePortalProvider mode="event">
      <JobsListPage portalMode="event" />
    </WorkspacePortalProvider>
  )
}
